var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAyeAssistantBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2718 13.7628C19.2718 14.141 18.9256 14.4872 18.2332 14.8068C17.6366 15.0837 17.1199 15.2276 16.6885 15.2222C15.6179 15.2222 14.6751 14.6789 13.8655 13.5923L9.49782 7.75459L5.59355 13.8906C4.75197 14.9612 3.71865 15.4992 2.48292 15.4992C1.9556 15.4939 1.43894 15.382 0.959561 15.169C0.32039 14.908 0.000804371 14.5724 0.000804371 14.1569C-0.00452205 14.0611 0.0167836 13.9705 0.059395 13.8906L7.30866 1.6292C7.90522 0.878176 8.61896 0.5 9.45521 0.5C10.2915 0.5 11.0372 0.878176 11.6337 1.63453L19.2398 13.5817C19.2611 13.6403 19.2718 13.7042 19.2718 13.7628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49219 7.77549L12.4643 2.95508L19.0798 13.3576C19.0798 13.3576 19.5804 13.8103 18.9572 14.3696C18.3341 14.9289 17.2262 15.2005 16.9385 15.2378C16.6509 15.2751 15.575 15.2857 14.7121 14.5187C14.1155 13.9861 13.8971 13.6559 13.8971 13.6559L11.2499 10.1351L9.49219 7.77549Z",
    fill: "url(#paint0_linear_1802_1673)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1802_1673",
    x1: 12.8995,
    y1: 13.6425,
    x2: 17.2347,
    y2: 5.49205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ABADAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyeAssistantBtn);
export default __webpack_public_path__ + "static/media/Aye-Assistant-btn.c679e21ce49ee7c0030d2ec55496dd6f.svg";
export { ForwardRef as ReactComponent };